import { useTranslation } from 'react-i18next';

import { paths } from 'src/routes/paths';
import { CONFIG } from 'src/config-global';
import { useJsonLd } from 'src/hooks/use-json-ld';
import { CtaDuo } from 'src/components/cta-duo';
import { PageSeo } from 'src/components/page-seo';
import { PageHero } from 'src/components/page-hero';
import { CardGrid } from 'src/components/card-grid';
import { StatsGrid } from 'src/components/stats-grid';
import { Manifesto } from 'src/components/manifesto';
import { SectionHead } from 'src/components/section-head';

export function AboutView() {
  const { t } = useTranslation('about');
  const { t: tCommon } = useTranslation('common');

  useJsonLd({
    '@type': 'AboutPage',
    name: t('hero.eyebrow'),
    '@context': 'https://schema.org',
    description: t('meta.description'),
    url: `${CONFIG.siteUrl}${paths.about}`,
  });

  return (
    <>
      <PageSeo path={paths.about} title={t('meta.title')} description={t('meta.description')} />

      <PageHero
        lead={t('hero.lead')}
        title={t('hero.title')}
        eyebrow={t('hero.eyebrow')}
        current={t('hero.breadcrumb')}
        links={[{ to: paths.home, label: tCommon('labels.home') }]}
      />

      <Manifesto compact ns="about" />

      <section className="section flush-top">
        <div className="container">
          <StatsGrid items={t('stats.items', { returnObjects: true })} />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead title={t('values.title')} eyebrow={t('values.eyebrow')} />
          <CardGrid items={t('values.items', { returnObjects: true })} />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead title={t('competences.title')} eyebrow={t('competences.eyebrow')} />
          <CardGrid columns={2} items={t('competences.items', { returnObjects: true })} />
        </div>
      </section>

      <div role="presentation" className="horizon" />

      <section className="section day">
        <div className="container">
          <CtaDuo
            primary={{
              to: paths.contact,
              label: t('cta.primary.label'),
              title: t('cta.primary.title'),
              action: t('cta.primary.action'),
            }}
            secondary={{
              to: paths.servicesAnchor,
              label: t('cta.secondary.label'),
              title: t('cta.secondary.title'),
              action: t('cta.secondary.action'),
            }}
          />
        </div>
      </section>
    </>
  );
}
